"use client";

import clsx from "clsx";
import Link from "next/link";
import Logo from "components/logo";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import { PhoneBtn } from "components/ui/phone";
import useScroll from "hooks/useScroll";
import { APP_LANGUAGES } from "utils/language";

const SimpleNav = ({
  inEditor,
  language = APP_LANGUAGES.ENGLISH
}: {
  inEditor?: boolean;
  language?: APP_LANGUAGES;
}) => {
  const scrolled = useScroll(5);

  return (
    <div
      id="SimpleNav-134"
      className={clsx(
        "z-40 w-full",
        inEditor ? "relative" : "sticky inset-x-0 top-0 ",
        scrolled
          ? "shadow-[#0000001a 0px 1px 0px 0px] border-b-[1px] bg-white"
          : "border-b border-t-0 border-transparent"
      )}
    >
      <MaxWidthWrapper>
        <div className="flex h-24 sm:h-16">
          <div className="flex w-full items-start justify-between space-x-2 text-primary-700 max-sm:pt-3 sm:items-center  xl:space-x-5">
            <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
              <Link href="/" className="cursor-pointer">
                <Logo />
              </Link>
            </div>

            <div className="ml-auto flex max-sm:mt-2 lg:space-x-2 xl:space-x-4">
              <PhoneBtn language={language} />
            </div>
          </div>
        </div>
      </MaxWidthWrapper>
    </div>
  );
};

export default SimpleNav;
